import { Model } from 'modules/core/lib/mobx-rest'

interface IFavouriteDashboard {
  [key: string]: any
}

class FavouriteDashboard extends Model<IFavouriteDashboard> {
  static urlRoot() {
    return '/api/rest/reports/favourite'
  }
}

export default FavouriteDashboard
